"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CreateExternalClaimRequest = /** @class */ (function () {
    function CreateExternalClaimRequest() {
    }
    return CreateExternalClaimRequest;
}());
exports.default = CreateExternalClaimRequest;
//# sourceMappingURL=CreateExternalClaimRequest.js.map